module.exports = __webpack_public_path__ + "img/logomenu.e261c9b3.png";